// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateStripeSetting_createButton__1C2_p","buttonsContainer":"CreateStripeSetting_buttonsContainer__PYFAI"};